import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { Upload, Plus } from 'lucide-react';
import { usePageConfig } from '../../contexts/PageConfigContext';
import { ProductsList } from './components/ProductsList';
import { ProductForm } from './components/ProductForm';
import { ProductExcelImport } from './components/ProductExcelImport';
import { Permissions } from '../../constants/permissions';

export const ProductsPage: React.FC = () => {
  const { setPageConfig } = usePageConfig();
  const navigate = useNavigate();
  
  // Dialog States
  const [showImportDialog, setShowImportDialog] = useState(false);
  const [showFormDialog, setShowFormDialog] = useState(false);
  const [editingProductId, setEditingProductId] = useState<string | undefined>(undefined);
  
  // List Refresh State
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreate = () => {
    setEditingProductId(undefined);
    setShowFormDialog(true);
  };

  const handleEdit = (id: string) => {
    setEditingProductId(id);
    setShowFormDialog(true);
  };

  const handleFormSuccess = () => {
    setShowFormDialog(false);
    setRefreshKey(prev => prev + 1);
  };

  React.useEffect(() => {
    setPageConfig({
      title: 'Productos',
      actions: [
        {
          label: 'Importar',
          icon: Upload,
          onClick: () => setShowImportDialog(true),
          variant: 'secondary' as const,
          permission: Permissions.Items.Create,
          iconOnly: true,
          tooltip: 'Importar desde Excel'
        },
        {
          label: 'Nuevo Producto',
          icon: Plus,
          onClick: handleCreate,
          variant: 'primary' as const
        }
      ]
    });
  }, [setPageConfig]);

  return (
    <div className="w-full">
      <ProductsList 
        key={refreshKey} 
        onEdit={handleEdit} 
        onDelete={() => setRefreshKey(prev => prev + 1)} 
      />
      
      {/* Import Dialog */}
      <ProductExcelImport
        isOpen={showImportDialog}
        onClose={() => setShowImportDialog(false)}
        onSuccess={() => setRefreshKey(prev => prev + 1)}
      />

      {/* Create/Edit Form Dialog (Integrated) */}
      <ProductForm
        isOpen={showFormDialog}
        onOpenChange={setShowFormDialog}
        productId={editingProductId}
        onClose={() => setShowFormDialog(false)}
        onSuccess={handleFormSuccess}
      />
    </div>
  );
};
